import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export default function DataConsumer(props) {
  var WrapperElement = props.isInline ? 'span' : 'div';
  return /*#__PURE__*/React.createElement(WrapperElement, _extends({
    "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
    "data-mark-type": "dataConsumer"
  }, props.dataAttributes), props.children);
}